class RichText extends HTMLElement {
  constructor() {
    super();
    this.trigger = this.querySelector('[data-rich-text-toggle]');
    this.wrapper = this.querySelector('[data-rich-text-content]');

    if (!this.trigger || !this.wrapper) return;

    this.content = this.wrapper.querySelector('[data-rich-text]');
    this.maxHeight = +this.wrapper.dataset.richTextContent;

    // Check the height for each event
    window.addEventListener('on:debounced-resize', this.checkDescription.bind(this));
    window.addEventListener('load', this.checkDescription.bind(this));

    this.trigger.addEventListener('click', () => {
      const isExpanded = this.ariaExpanded;
      const scrollIntoView = () => {
        this.scrollIntoView({ behavior: 'smooth',
          block: 'start',
          inline: 'nearest' });

        this.wrapper.removeEventListener('transitionend', scrollIntoView);
      };

      this.wrapper.classList.toggle('show_text');
      this.wrapper.addEventListener('transitionend', scrollIntoView);

      if (isExpanded == 'true') {
        this.ariaExpanded = false;
      }
      else {
        this.ariaExpanded = true;
      }
    });

    document.addEventListener('shopify:section:load', () => {
      this.checkDescription();
    });
  }
  checkDescription() {
    // for the description, hide the 'show more' trigger when the height isn't big enough
    const elementHeight = this.content.clientHeight;
    console.log(elementHeight, this, this.maxHeight);

    if (this.maxHeight > elementHeight) {
      this.trigger.classList.add('hidden');
      this.wrapper.classList.remove('truncate');
    }
    else {
      this.trigger.classList.remove('hidden');
      this.wrapper.classList.add('truncate');
    }
  }
}
if (!customElements.get('rich-text')) {
  customElements.define('rich-text', RichText);
}